import styled from "styled-components";
import LoginForm from "../features/authentication/LoginForm";
import Heading from "../ui/Heading.jsx";

const LoginLayout = styled.main`
    
    & > .card {
        width: 100%;
        max-width: 28rem;
        background: white;
    }
`;

function Login() {
    return (
        <LoginLayout>
            <div className="relative flex flex-col items-center  pt-10">
                <Heading className="text-center font-bold mb-4">
                    Log in to your account
                </Heading>
                <LoginForm />
            </div>
        </LoginLayout>
    );
}

export default Login;
